import { Container, Typography } from '@mui/material';

export default function NoAccessPage() {
  return (
    <Container
      maxWidth="md"
      className="flex flex-col align-middle items-center justify-center min-h-screen text-center "
    >
      <Typography
        variant="h4"
        color="error"
        className="font-bold"
        sx={{ mb: 2, mt: 10, textAlign: 'center' }}
      >
        คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้{' '}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 1, mb: 3, textAlign: 'center' }}>
        กรุณาเปลี่ยนบทบาท/หน้าที่ของคุณให้ถูกต้อง หรือ ติดต่อผู้ดูแลระบบหากพบปัญหา
      </Typography>

      {/* <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/')}
        startIcon={<Iconify icon="ic:round-home" />}
        sx={{ borderRadius: 3, px: 4 }}
      >
        Go to Home
      </Button> */}
    </Container>
  );
}
